
import { useQuery } from '@tanstack/react-query';
import { MOOD_FILTERS, MoodFilterData } from '../data/mood-filters';

/**
 * Hook to fetch mood prompts from static data
 */
export const useStaticMoodPrompts = () => {
  return useQuery({
    queryKey: ['static-mood-prompts'],
    queryFn: async (): Promise<MoodFilterData[]> => {
      // Simulate async behavior to maintain interface compatibility
      await new Promise(resolve => setTimeout(resolve, 1));
      
      return MOOD_FILTERS.sort((a, b) => b.priority - a.priority);
    },
    staleTime: Infinity, // Static data never goes stale
    gcTime: Infinity, // Keep in cache forever
  });
};
